/**
 * Centralized external links
 * Edit these values to update URLs across the entire site.
 */

/** PrismScope demo conversation — used for "Try a Conversation" CTAs */
export const DEMO_SURVEY_URL = 'https://rays.prismscope.ai/i/int_ONF-JNX1Zq0CyFEt0jzyGA?skip=1'

/** PrismScope app / sign-up — used for "Get Started" and "Log In" */
export const APP_URL = 'https://rays.prismscope.ai/admin'

/** Waitlist sign-up — used for beta access and Voice of Employee waitlist CTAs */
export const WAITLIST_URL = 'https://accounts.prismscope.ai/waitlist'
